// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2Yixz","label":"LabeledBox_label__3-QBT"};